var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSchedule(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 5.33333V4.66667C0.5 2.82867 1.99533 1.33333 3.83333 1.33333H4.5V0.666667C4.5 0.298667 4.798 0 5.16667 0C5.53533 0 5.83333 0.298667 5.83333 0.666667V1.33333H11.1667V0.666667C11.1667 0.298667 11.4647 0 11.8333 0C12.202 0 12.5 0.298667 12.5 0.666667V1.33333H13.1667C15.0047 1.33333 16.5 2.82867 16.5 4.66667V5.33333H0.5ZM16.5 6.66667V12.6667C16.5 14.5047 15.0047 16 13.1667 16H3.83333C1.99533 16 0.5 14.5047 0.5 12.6667V6.66667H16.5ZM8.5 12.6667C8.5 12.2987 8.202 12 7.83333 12H4.5C4.13133 12 3.83333 12.2987 3.83333 12.6667C3.83333 13.0347 4.13133 13.3333 4.5 13.3333H7.83333C8.202 13.3333 8.5 13.0347 8.5 12.6667ZM13.1667 10C13.1667 9.632 12.8687 9.33333 12.5 9.33333H4.5C4.13133 9.33333 3.83333 9.632 3.83333 10C3.83333 10.368 4.13133 10.6667 4.5 10.6667H12.5C12.8687 10.6667 13.1667 10.368 13.1667 10Z",
    fill: "#2F4858"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedule);
export default __webpack_public_path__ + "static/media/schedule.ef48020eb2a748007c3638b64c604e7a.svg";
export { ForwardRef as ReactComponent };